var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocalBlock = function SvgLocalBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F8F8F8",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B4450",
    d: "m13.618 22.25.871 1.085c-.743.458-1.176.985-1.176 1.489 0 1.308 2.86 2.77 6.687 2.77 3.827 0 6.687-1.462 6.687-2.77 0-.462-.373-.942-1.003-1.371l.962-1.015c.859.667 1.353 1.485 1.354 2.384C28 27.204 24.561 29 20 29s-8-1.797-8-4.178c0-.988.599-1.873 1.618-2.572zM20 11c3.435 0 6.222 2.753 6.222 6.15A6.092 6.092 0 0 1 24.4 21.5L20 25.85l-4.4-4.348a6.092 6.092 0 0 1-1.822-4.35C13.778 13.754 16.565 11 20 11zm0 1.313c-2.698 0-4.894 2.17-4.894 4.84 0 1.291.51 2.505 1.434 3.42l3.46 3.42 3.46-3.42a4.776 4.776 0 0 0 1.434-3.42c0-2.67-2.196-4.84-4.894-4.84zm.222 2.737c.407 0 .812.17 1.1.461.288.292.456.702.456 1.114 0 .412-.168.822-.456 1.114a1.564 1.564 0 0 1-1.1.461c-.407 0-.812-.17-1.1-.461a1.603 1.603 0 0 1-.455-1.114c0-.412.167-.822.455-1.114a1.565 1.565 0 0 1 1.1-.461z"
  }))));
};
export default SvgLocalBlock;